import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { DialogTitle } from '@mui/material';

export const CustomDialog = ({ content, open, title, close }) => {
  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
    </Dialog>
  );
};
